import React from 'react';
import './UpDownCaret.css';

export const UpDownCaret = ({ display, handleClick }) => {
  if (display === 'expand') {
    return (
      <button onClick={handleClick} className="upDownCaret">
        <span className="upCaret" aria-label="Up Arrow" />
      </button>
    );
  } else {
    return (
      <button onClick={handleClick} className="upDownCaret">
        <span className="downCaret" aria-label="Down Arrow" />
      </button>
    );
  }
};
